.product-list-teaser {
  position: relative;
  width: 100%;
  height: 100%;

  @include supportedColors();

  div.text {
    position: relative;
    top: 10px;
    left: 10px;
    padding-right: 10px;

    @include breakpointMin('lg') {
      top: 30px;
      left: 30px;
      padding-right: 30px;
    }

    .heading {
      padding-bottom: 11px;

      @include breakpointMin('lg') {
        padding-bottom: 17px;
      }
    }

    .subtitle {
      padding-bottom: 8px;

      @include breakpointMin('lg') {
        padding-bottom: 10px;
      }
    }
  }

  ::slotted(img) {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
  }

  a {
    text-decoration: none;
  }
}